import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import { toast } from "react-toastify";
import ReferrerList from "./ReferrerList";
import AddEditReferrer from "./AddEditReferrer";
import { addReferrer } from "services/referrersService";

const Referrers = (props) => {
  const [addnewform, setaddnewform] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const closeform = () => {
    setaddnewform(false);
  };
  React.useEffect(() => {
    if (props.onClose === false) {
      closeform();
    }
  }, [props.onClose]);

  const handleSubmit = async (event) => {
    try {
      setIsSubmitting(true);
      let type;
      if (event.forMatters && event.forClients) {
        type = "Both";
      } else if (event.forMatters) {
        type = "Matter";
      } else if (event.forClients) {
        type = "Client";
      } else {
        type = "Both";
      }
      const postingData = {
        ...event,
        active: true,
        referrerType: type,
      };
      const result = await addReferrer(postingData);
      if (result.success) {
        toast.success("Referrer Added successfully");
      }
      setaddnewform(false);
    } catch (error) {
      toast.error("An error occurred while adding referrer");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn p-2`}
          onClick={() => {
            setaddnewform(true);
          }}
        >
          Add <br />
          Referrer
        </Button>
      </div>

      <div className="flex-grow-1 settings-grid-wrapper referrer-grid-wrapper mb-2" style={{ minHeight: 0 }}>
        <ReferrerList />
      </div>

      {addnewform && (
        <AddEditReferrer
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default Referrers;
